import {Component} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";
import {MfaService} from "../../../_services/mfa.service";
import {AppModule} from "../../../app.module";
import {AlertService} from "../../../_services";
import {AlertType} from "../../../_models";
import {Router} from "@angular/router";

@Component({
    standalone: false,
  selector: "setup-mfa-totp",
  templateUrl: 'setup-totp.component.html',
  styleUrls: ['./setup-totp.component.scss'],
})
export class SetupTotpComponent {
  otpQr: any = null;
  code: string = "";

  constructor(public mfaService: MfaService,
              public sanitizer: DomSanitizer,
              public router: Router) {
    this.init();
  }

  init() {
    this.otpQr = null;
    this.mfaService.initSetup('totp').subscribe(
      r => this.otpQr = r,
      e => { console.log(e); this.router.navigate(['mfa']); });
  }

  submit() {
    const alertService = AppModule.injector.get(AlertService);
    alertService.loading.next(true)
    this.mfaService.completeSetup('totp', this.code).subscribe(s => {
      alertService.loading.next(false)
      this.router.navigate(['mfa'])
    }, e => {
      alertService.loading.next(false)
      alertService.alert(AlertType.Error, e.error.exceptionMessage)
    })
  }
}
